import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { setModalState } from '../../../../reducers/Modal/actions';

import { MODAL_UNSAVED_BUYBOX_CHANGES } from '../../../../reducers/Modal/types';
import { ZorbaButton } from '../../../../components/forms';

import './index.scss';
import { BUTTON_VARIANT_DARK } from '../../../../components/forms/ZorbaButton/constants';

export const UnsavedBuyBoxChangesModal = ({ handleDiscardChanges }) => {
  const dispatch = useDispatch();
  const { isUnsavedBuyBoxChangesModalOpen } = useSelector(
    ({ ModalReducer }) => ModalReducer,
  );
  const handleClose = () => {
    dispatch(setModalState(MODAL_UNSAVED_BUYBOX_CHANGES, false));
  };

  return (
    <Modal
      open={isUnsavedBuyBoxChangesModalOpen}
      footer={null}
      onCancel={handleClose}
      title="Unsaved Changes"
      destroyOnClose
      className="unsaved-buybox-changes-modal"
    >
      <p>
        You have unsaved changes in this buy box. Are you sure you want to
        switch buy boxes and discard those changes?
      </p>
      <div className="buttons-container">
        <div className="button-container">
          <ZorbaButton fullWidth onClick={handleDiscardChanges}>
            Discard changes
          </ZorbaButton>
        </div>
        <div className="button-container">
          <ZorbaButton
            variant={BUTTON_VARIANT_DARK}
            fullWidth
            onClick={handleClose}
          >
            Cancel
          </ZorbaButton>
        </div>
      </div>
    </Modal>
  );
};
